import { Component } from "@angular/core";
import { Router, UrlSerializer } from "@angular/router";
import { QuizService } from '../../../Service/Quizservice';

import { MatSnackBar } from '@angular/material/snack-bar';
import CryptoJS from 'crypto-js';
import { dataFor } from 'knockout';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import { HttpClient, HttpHeaders } from '@angular/common/http';


@Component({
    selector: "Studenthome-page",
    templateUrl: "./Studenthome.page.html",
    styleUrls: ["./Student.css"],
})
export class StudenthomePage {
    status: any;
    Studentstatus: any;
    quizid;
    Studentname: any = '';
    Studentroute;
    disabled = true;
    curr;
    dates:any;
    stdhomepage: FormGroup;
    ngOnInit() {

        this.stdhomepage = new FormGroup({
            studentname: new FormControl('')
        });
    }
    constructor(private http: HttpClient,private QuizService: QuizService, private router: Router, private _snackBar: MatSnackBar) {
        this.getconfigkey();
        var quizid1 = this.router.url;
        var valufin = quizid1.replace('/', '');
        this.curr = new Date().toISOString();
        var code = [
            {
                "code": valufin,
            }];
        setTimeout(() => {
            this.QuizService.getassignmentid(JSON.stringify(code)).subscribe(data => {
                //console.log(JSON.stringify(data));
                if((JSON.parse(JSON.stringify(data))['status']) == "S002")
                {
                this.status = "S002"
                }
                else{
                this.quizid = data.toString();
                sessionStorage.setItem("quizid", data.toString());
                
                var jsonobj = [
                    {
                        "id": this.quizid,
                        "ispublished": 1,
                        "startdate": { $lte: this.curr },
                        "enddate": { $gte: this.curr }
                    }];                
                setTimeout(() => {
                    this.QuizService.getquizbyid(JSON.stringify(jsonobj))
                        .subscribe(data => {
                            this.status = (JSON.parse(JSON.stringify(data))['status'])
                        });
                }, 100);
            }})

        }, 200);
        
    }
    routgen() {
        this.Studentname = this.stdhomepage.get("studentname").value;
        if (this.Studentname.trim() != '') {
            this.dates=new Date();
            var jsonobj1 = [
                {
                    "Quizid": this.quizid,
                    "studentname": this.Studentname,
                    "Attendeddate":new Date(this.dates.getTime() - (this.dates.getTimezoneOffset() * 60000)).toISOString().slice(0,16)
                }];
            console.log(jsonobj1);
            this.QuizService.addstudentdata(JSON.stringify(jsonobj1))
                .subscribe(data => this.routequiz(JSON.parse(JSON.stringify(data))['status']));

        }
        else {
            this._snackBar.open("Please enter your name.", "Ok", {
                duration: 2000,
            });
        }
    }
    routequiz(obj) {
        if (obj == "S002") {
            var snackBarRef = this._snackBar.open("Name already exist! Please enter the different name.", "Ok", {

            });
            snackBarRef.onAction().subscribe(() => {
            });
        }
        else {
            var encryptedval = CryptoJS.AES.encrypt(obj.trim(), 'q').toString();
            sessionStorage.setItem("sid", encryptedval)
            sessionStorage.setItem("studname", this.Studentname)
            var quizid = this.router.url;
            var valufin = quizid.split('/')[1];
            var jsonobj = [
                {
                    "id": this.quizid,
                    "ispublished": 1
                }];
            this.QuizService.getquizretdatabyid(JSON.stringify(jsonobj))
                .subscribe(data => { sessionStorage.setItem("editdata", JSON.stringify(data)) });
            var encryptedval = CryptoJS.AES.encrypt(this.quizid, 'q').toString();
            setTimeout(() => {
                this.router.navigate([valufin + "/student"], { queryParams: { Asid: encryptedval } })
            }, 1000);
        }
    }
    async  getconfigkey() {
        var data1=await this.http.get("assets/env.json");
        data1.subscribe(data=>{
           sessionStorage.setItem("uploadurl",data['uploadurl'])
        });
    
        // return this.http.get("/AssignmentToolbox/assets/env.json");
      }
}
